import { createAction } from 'redux-starter-kit';

/**
 * An action creator for putting an outcome into the state.
 * @param {object} outcome The outcome object.
 * @example dispatch(putOutcome(outcome))
 */
export const putOutcome = createAction('PUT_OUTCOME');

/**
 * An action creator for replacing all outcomes in the state
 * @param {object[]} outcomes A list of outcomes.
 * @example dispatch(putOutcomes(outcomes))
 */
export const putOutcomes = createAction('PUT_OUTCOMES');
